var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.517 14C27.517 6.538 21.462.483 14 .483S.483 6.538.483 14 6.538 27.517 14 27.517 27.517 21.462 27.517 14zm-19.6-2.703h12.166L14 19.407l-6.083-8.11z"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/more-menu.svg";
export { SvgMoreMenu as ReactComponent };